export const LOCALE_PREFIX_ENTITY = 'components.Entity'
export const LOCALE_PREFIX_ROLE = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.RolesInCompanies'
